import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'Snippets/Neumorphism' 

const WarningTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired
}

const Warning = ({title, message}) => {
    const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
    
    useEffect(() => {
		const cleanup = setTimeout(() => setShow(true), 500)
		return () => clearTimeout(cleanup)
    }, [])
    
    return (
		<Modal show={show} size='sm'>
            <Modal.Title onHide={handleClose}>{title}</Modal.Title>
            <Modal.Body>
                {message}
            </Modal.Body>
            <Modal.Footer>
                <button className='n-btn' onClick={handleClose}>
                    Okay
                </button> 
            </Modal.Footer>
        </Modal>
    )
}

Warning.propTypes = WarningTypes

export default Warning;
